import { fetchAsObservable } from 'fetcher!sofe';

export function getSuccessfulTranscriptsCount() {
  return fetchAsObservable(`/api/transcripts/trial-count`);
}

export function getNoticesCount() {
  return fetchAsObservable(`/api/notices/trial-count`);
}
